import { cva } from 'class-variance-authority';

export type StatusColors =
  | 'green'
  | 'red'
  | 'orange'
  | 'blue'
  | 'grey'
  | 'yellow'
  | 'brown'
  | 'violet'
  | 'rose'
  | 'moonstone';

export const statusColors = cva('', {
  variants: {
    text: {
      green: 'text-text-status-green-darker',
      red: 'text-text-state-error-dark',
      orange: 'text-text-status-orange-darker',
      blue: 'text-text-status-navy-darker',
      grey: 'text-text-status-grey-darker',
      yellow: 'text-text-status-yellow-darker',
      brown: 'text-text-status-brown-darker',
      violet: 'text-text-status-violet-darker',
      rose: 'text-text-status-rose-darker',
      moonstone: 'text-text-status-moonstone-extra-dark',
    },
    outlined: {
      green: 'border border-border-status-green',
      red: 'border border-border-status-red',
      orange: 'border border-border-status-orange-lighter',
      blue: 'border border-border-status-navy',
      grey: 'border border-border-status-grey',
      yellow: 'border border-border-status-yellow-lighter',
      brown: 'border border-border-status-brown',
      violet: 'border border-border-status-violet',
      rose: 'border border-border-status-rose',
      moonstone: 'border border-border-status-moonstone',
    },
    contained: {
      green: 'border border-border-status-green bg-surface-highlight',
      red: 'border border-border-status-red bg-surface-status-red-lighter',
      orange: 'border border-border-status-orange-lighter bg-surface-status-orange-lighter',
      blue: 'border border-border-status-navy bg-surface-status-navy-lighter',
      grey: 'border border-border-status-grey bg-surface-status-grey-lighter',
      yellow: 'border border-border-status-yellow-lighter bg-surface-status-yellow-lighter',
      brown: 'border border-border-status-brown bg-surface-status-brown-lighter',
      violet: 'border border-border-status-violet bg-surface-status-violet-lighter',
      rose: 'border border-border-status-rose bg-surface-status-rose-lighter',
      moonstone: 'border border-border-status-moonstone bg-surface-status-moonstone-lighter',
    },
    dotBorder: {
      green: 'border-border-status-green-darker',
      red: 'border-border-status-red-darker',
      orange: 'border-border-status-orange-darker',
      blue: 'border-border-status-navy-darker',
      grey: 'border-border-status-grey-darker',
      yellow: 'border-border-status-yellow-darker',
      brown: 'border-border-status-brown-darker',
      violet: 'border-border-status-violet-darker',
      rose: 'border-border-status-rose-darker',
      moonstone: 'border-border-status-moonstone-darker',
    },
    dotBg: {
      green: 'bg-surface-status-green-darker',
      red: 'bg-surface-status-red-darker',
      orange: 'bg-surface-status-orange-darker',
      blue: 'bg-surface-status-navy-darker',
      grey: 'bg-surface-status-grey-darker',
      yellow: 'bg-surface-status-yellow',
      brown: 'bg-surface-status-brown-darker',
      violet: 'bg-surface-status-violet-darker',
      rose: 'bg-surface-status-rose-darker',
      moonstone: 'bg-surface-status-moonstone',
    },
    icon: {
      green: 'text-icon-status-green',
      red: 'text-icon-status-red',
      orange: 'text-icon-status-orange',
      blue: 'text-icon-status-navy',
      grey: 'text-icon-status-grey',
      yellow: 'text-icon-status-yellow',
      brown: 'text-icon-status-brown',
      violet: 'text-icon-status-violet',
      rose: 'text-icon-status-rose',
      moonstone: 'text-icon-status-moonstone',
    },
    dotTextText: {
      green: 'text-text-status-green-lighter',
      red: 'text-text-status-red-lighter',
      orange: 'text-text-status-orange-lighter',
      blue: 'text-text-status-navy-lighter',
      grey: 'text-text-status-grey-lighter',
      yellow: 'text-text-status-yellow-lighter',
      brown: 'text-text-status-brown-lighter',
      violet: 'text-text-status-violet-lighter',
      rose: 'text-text-status-rose-lighter',
      moonstone: 'text-text-status-moonstone-lighter',
    },
  },
});
